import { render, staticRenderFns } from "./ProductsInformation.vue?vue&type=template&id=ade98786&scoped=true"
import script from "./ProductsInformation.vue?vue&type=script&lang=js"
export * from "./ProductsInformation.vue?vue&type=script&lang=js"
import style0 from "./ProductsInformation.vue?vue&type=style&index=0&id=ade98786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade98786",
  null
  
)

export default component.exports